import {
  FETCH_DIRECTORS_REQUEST,
  FETCH_DIRECTORS_SUCCESS,
  FETCH_DIRECTORS_FAILURE
} from '../actions';

const defaultDirectorsState = {
  directors: [],
  loading: false,
  // TODO: remove loaded
  loaded: false,
  error: false
};

const reducer = (state = defaultDirectorsState, action) => {
  switch(action.type){
    case FETCH_DIRECTORS_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false
      };
    case FETCH_DIRECTORS_SUCCESS:
      return {
        ...state,
        directors: action.directors,
        loading: false,
        loaded: true
      };
    case FETCH_DIRECTORS_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true
      };
    default:
      return state;
  }
}


export default reducer;
